import { render, staticRenderFns } from "./printTemplate1.vue?vue&type=template&id=2fcef2b2&scoped=true&"
import script from "./printTemplate1.vue?vue&type=script&lang=js&"
export * from "./printTemplate1.vue?vue&type=script&lang=js&"
import style0 from "./printTemplate1.vue?vue&type=style&index=0&id=2fcef2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcef2b2",
  null
  
)

export default component.exports